import React from "react";
import { Search, X, Loader2 } from "lucide-react";

export default function SearchBar({ value, onChange, loading, placeholder = "Search products…" }) {
  return (
    <div className="relative w-full">
      <Search className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400" aria-hidden="true" />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => e.key === "Escape" && onChange("")}
        placeholder={placeholder}
        autoFocus
        autoComplete="off"
        spellCheck={false}
        maxLength={100}
        aria-label="Search products"
        className="w-full rounded-xl border border-gray-200 bg-white py-3 pl-12 pr-12 text-base text-gray-900 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 [&::-webkit-search-cancel-button]:hidden"
      />
      <div className="absolute right-3 top-1/2 flex -translate-y-1/2 items-center">
        {loading ? (
          <Loader2 className="h-5 w-5 animate-spin text-gray-400" aria-label="Searching" />
        ) : value ? (
          <button
            type="button"
            onClick={() => onChange("")}
            className="rounded-full p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
            aria-label="Clear search"
          >
            <X className="h-5 w-5" />
          </button>
        ) : null}
      </div>
    </div>
  );
}
